import { Header } from "../../header/Header";
import { Footer } from "../footer/Footer";
import { Joinus } from "../joinus/Joinus";
import a1 from "../../assets/a1.jpg";
import '../aboutus/About.css';
import { ServicesShowcaseCouple } from "../service/ServicesShowcaseCouple";

export const Couple = () => {
    return (
        <div>
            <Header />
            <div className="about-us">
            <div className="about-header">
              <h1>Couple Therapy</h1>
            </div>
            <div className="about-section">
                <img src={a1} alt="Mission" className="about-image" />
                <div className="about-text">
                  <p>
                    A lot of times couples do not get along and experience difficulties in their relationship. Couples or relationship therapy is designed for partners or two people involved with each other romantically. It focuses towards improvement of communication, resolves conflict and enhances the overall quality of the relationship. this therapy may also be helpful for couples who are dating or individuals who are planning to get married.
                    It also stands with a goal of developing healthy pattern of interaction and strengthens their emotional connection. This therapy works well through specific issues that may be causing distress in a relationship.
                  </p>
                </div>
            </div>
            </div>
            <ServicesShowcaseCouple />
            <Joinus />
            <Footer />
        </div>
    );
};